export default {"src":"/_next/static/media/timer.7515a61f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};